<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">Add {{ label }} Filter</span>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-if="label !== 'Source Country'"
          v-model="localValue"
          :label="label"
          @input="updateValue"
          :error-messages="errorMessage"
          :error="!!errorMessage"
          ref="input"
        ></v-text-field>
        <v-select
          v-else
          v-model="localValue"
          :items="countryOptions"
          item-text="name"
          item-value="code"
          :label="label"
          @change="updateValue"
          :error-messages="errorMessage"
          :error="!!errorMessage"
          ref="input"
        ></v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "FilterInput",
  props: ["value", "label", "validator", "countryOptions"],
  data() {
    return {
      dialog: true,
      localValue: this.value,
    };
  },
  computed: {
    errorMessage() {
      return this.validator && !this.validator(this.localValue)
        ? "Invalid input"
        : "";
    },
  },
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    },
    save() {
      if (!this.errorMessage) {
        this.$emit("input", this.localValue);
        this.close();
      }
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    },
    handleOutsideClick() {
      this.dialog = false;
      this.$emit("close");
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.$emit("close");
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.input.focus();
    });
  },
};
</script>
